import { render, staticRenderFns } from "./HomeView_三门峡.vue?vue&type=template&id=72cdd47e&scoped=true"
import script from "./HomeView_三门峡.vue?vue&type=script&lang=js"
export * from "./HomeView_三门峡.vue?vue&type=script&lang=js"
import style0 from "./HomeView_三门峡.vue?vue&type=style&index=0&id=72cdd47e&prod&lang=css"
import style1 from "./HomeView_三门峡.vue?vue&type=style&index=1&id=72cdd47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdd47e",
  null
  
)

export default component.exports